import React from 'react';

import {
    ImageTextBlock,
    Image,
    Text
  } from './styled-components';

export const imagePositions = {
    LEFT:"left",
    RIGHT:"right"
}

/**
 * either display the section with padding around it or not
 */
export const sectionStyles = {
    FULLSIZE: 0,
    INDENTED: 1,
  };

/**
 *  @param {string} imageUrl - image url
 *  @param {string} imagePosition - left or right from text, on mobile left = on top
 *  @param {string} text - richt text to be displayed next to the image
 *  @param {enum: FULLSIZE, INDENTED} sectionStyle - defines the padding of the section
 */

 const ImageWithText = ({
     imageUrl,
     imagePosition,
     text,
 }) => {

    return <ImageTextBlock imagePosition={imagePosition}>
                <Image>
                    <img src={imageUrl} alt='' />
                </Image>
                <Text>
                    {text}
                </Text>
        </ImageTextBlock>
 }

 ImageWithText.defaultProps = {
    text:undefined,
    imagePosition: undefined,
    imageUrl: undefined
 }

 export const test = {
    imageUrl:"http://rothierdesign.com/projects/giesswein/merinowool/images/bg-sec11.jpg",
    imagePosition:imagePositions.LEFT,
    text:`<><h2><strong>Lorem ipsum dolor sit amet</strong></h2><p>consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco</p></>`
 }

 export default ImageWithText